import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-dialog-confirm-changes',
    templateUrl: './dialog-confirm-changes.component.html',
    styles: [],
    standalone: false
})
export class DialogConfirmChangesComponent implements OnInit {
  public isMobile: boolean;
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmChangesComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.isMobile = environment.platform === 'mobile';
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
